/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __awaiter, __extends, __generator } from "tslib";
import * as runtime from '../runtime';
import { PagedResponseOfUserListEntryFromJSON, UserCreationRequestToJSON, UserResponseFromJSON, UserSelfUpdateRequestToJSON, UserUpdateRequestToJSON, } from '../models';
/**
 *
 */
var UserRestControllerApi = /** @class */ (function (_super) {
    __extends(UserRestControllerApi, _super);
    function UserRestControllerApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a new user  \'Permission#CREATE_USER\' is required to access to this endpoint
     * Create a new user  \'Permission#CREATE_USER\' is required to access to this endpoint
     */
    UserRestControllerApi.prototype.createUserRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.userCreationRequest === null || requestParameters.userCreationRequest === undefined) {
                            throw new runtime.RequiredError('userCreationRequest', 'Required parameter requestParameters.userCreationRequest was null or undefined when calling createUser.');
                        }
                        queryParameters = {};
                        if (requestParameters.contextOrganisation !== undefined) {
                            queryParameters['contextOrganisation'] = requestParameters.contextOrganisation;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("keycloak", [])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/users",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: UserCreationRequestToJSON(requestParameters.userCreationRequest)
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return UserResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Create a new user  \'Permission#CREATE_USER\' is required to access to this endpoint
     * Create a new user  \'Permission#CREATE_USER\' is required to access to this endpoint
     */
    UserRestControllerApi.prototype.createUser = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createUserRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete current user (self-service function for logged on user)  User must be authenticated to access to this endpoint
     * Delete current user (self-service function for logged on user)  User must be authenticated to access to this endpoint
     */
    UserRestControllerApi.prototype.deleteUserAuthorizationContextOrganisationRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.contextOrganisation !== undefined) {
                            queryParameters['contextOrganisation'] = requestParameters.contextOrganisation;
                        }
                        headerParameters = {};
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("keycloak", [])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/users/me",
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Delete current user (self-service function for logged on user)  User must be authenticated to access to this endpoint
     * Delete current user (self-service function for logged on user)  User must be authenticated to access to this endpoint
     */
    UserRestControllerApi.prototype.deleteUserAuthorizationContextOrganisation = function (requestParameters, initOverrides) {
        if (requestParameters === void 0) { requestParameters = {}; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteUserAuthorizationContextOrganisationRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Delete user  \'Permission#DELETE_USER\' is required to access to this endpoint
     * Delete user  \'Permission#DELETE_USER\' is required to access to this endpoint
     */
    UserRestControllerApi.prototype.deleteUserAuthorizationUserIdContextOrganisationRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.userId === null || requestParameters.userId === undefined) {
                            throw new runtime.RequiredError('userId', 'Required parameter requestParameters.userId was null or undefined when calling deleteUserAuthorizationUserIdContextOrganisation.');
                        }
                        queryParameters = {};
                        if (requestParameters.contextOrganisation !== undefined) {
                            queryParameters['contextOrganisation'] = requestParameters.contextOrganisation;
                        }
                        headerParameters = {};
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("keycloak", [])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/users/{userId}".replace("{".concat("userId", "}"), encodeURIComponent(String(requestParameters.userId))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Delete user  \'Permission#DELETE_USER\' is required to access to this endpoint
     * Delete user  \'Permission#DELETE_USER\' is required to access to this endpoint
     */
    UserRestControllerApi.prototype.deleteUserAuthorizationUserIdContextOrganisation = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteUserAuthorizationUserIdContextOrganisationRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get user details of current user (self-service function for logged on user)  User must be authenticated to access to this endpoint
     * Get user details of current user (self-service function for logged on user)  User must be authenticated to access to this endpoint
     */
    UserRestControllerApi.prototype.getUserAuthorizationContextOrganisationRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.contextOrganisation !== undefined) {
                            queryParameters['contextOrganisation'] = requestParameters.contextOrganisation;
                        }
                        headerParameters = {};
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("keycloak", [])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/users/me",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return UserResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get user details of current user (self-service function for logged on user)  User must be authenticated to access to this endpoint
     * Get user details of current user (self-service function for logged on user)  User must be authenticated to access to this endpoint
     */
    UserRestControllerApi.prototype.getUserAuthorizationContextOrganisation = function (requestParameters, initOverrides) {
        if (requestParameters === void 0) { requestParameters = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getUserAuthorizationContextOrganisationRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get user details  \'Permission#READ_USER\' is required to access to this endpoint
     * Get user details  \'Permission#READ_USER\' is required to access to this endpoint
     */
    UserRestControllerApi.prototype.getUserAuthorizationUserIdContextOrganisationRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.userId === null || requestParameters.userId === undefined) {
                            throw new runtime.RequiredError('userId', 'Required parameter requestParameters.userId was null or undefined when calling getUserAuthorizationUserIdContextOrganisation.');
                        }
                        queryParameters = {};
                        if (requestParameters.contextOrganisation !== undefined) {
                            queryParameters['contextOrganisation'] = requestParameters.contextOrganisation;
                        }
                        headerParameters = {};
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("keycloak", [])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/users/{userId}".replace("{".concat("userId", "}"), encodeURIComponent(String(requestParameters.userId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return UserResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get user details  \'Permission#READ_USER\' is required to access to this endpoint
     * Get user details  \'Permission#READ_USER\' is required to access to this endpoint
     */
    UserRestControllerApi.prototype.getUserAuthorizationUserIdContextOrganisation = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getUserAuthorizationUserIdContextOrganisationRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * List users using pagination  \'Permission#READ_USER\' is required to access to this endpoint
     * List users using pagination  \'Permission#READ_USER\' is required to access to this endpoint
     */
    UserRestControllerApi.prototype.listUsersRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.contextOrganisation !== undefined) {
                            queryParameters['contextOrganisation'] = requestParameters.contextOrganisation;
                        }
                        if (requestParameters.page !== undefined) {
                            queryParameters['page'] = requestParameters.page;
                        }
                        if (requestParameters.size !== undefined) {
                            queryParameters['size'] = requestParameters.size;
                        }
                        headerParameters = {};
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("keycloak", [])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/users",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return PagedResponseOfUserListEntryFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * List users using pagination  \'Permission#READ_USER\' is required to access to this endpoint
     * List users using pagination  \'Permission#READ_USER\' is required to access to this endpoint
     */
    UserRestControllerApi.prototype.listUsers = function (requestParameters, initOverrides) {
        if (requestParameters === void 0) { requestParameters = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.listUsersRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update current user details (self-service function for logged on user)  User must be authenticated to access to this endpoint
     * Update current user details (self-service function for logged on user)  User must be authenticated to access to this endpoint
     */
    UserRestControllerApi.prototype.updateUserAuthorizationContextOrganisationRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.userSelfUpdateRequest === null || requestParameters.userSelfUpdateRequest === undefined) {
                            throw new runtime.RequiredError('userSelfUpdateRequest', 'Required parameter requestParameters.userSelfUpdateRequest was null or undefined when calling updateUserAuthorizationContextOrganisation.');
                        }
                        queryParameters = {};
                        if (requestParameters.contextOrganisation !== undefined) {
                            queryParameters['contextOrganisation'] = requestParameters.contextOrganisation;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("keycloak", [])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/users/me",
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: UserSelfUpdateRequestToJSON(requestParameters.userSelfUpdateRequest)
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return UserResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Update current user details (self-service function for logged on user)  User must be authenticated to access to this endpoint
     * Update current user details (self-service function for logged on user)  User must be authenticated to access to this endpoint
     */
    UserRestControllerApi.prototype.updateUserAuthorizationContextOrganisation = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateUserAuthorizationContextOrganisationRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update user details  \'Permission#UPDATE_USER\' is required to access to this endpoint
     * Update user details  \'Permission#UPDATE_USER\' is required to access to this endpoint
     */
    UserRestControllerApi.prototype.updateUserAuthorizationUserIdContextOrganisationRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.userId === null || requestParameters.userId === undefined) {
                            throw new runtime.RequiredError('userId', 'Required parameter requestParameters.userId was null or undefined when calling updateUserAuthorizationUserIdContextOrganisation.');
                        }
                        if (requestParameters.userUpdateRequest === null || requestParameters.userUpdateRequest === undefined) {
                            throw new runtime.RequiredError('userUpdateRequest', 'Required parameter requestParameters.userUpdateRequest was null or undefined when calling updateUserAuthorizationUserIdContextOrganisation.');
                        }
                        queryParameters = {};
                        if (requestParameters.contextOrganisation !== undefined) {
                            queryParameters['contextOrganisation'] = requestParameters.contextOrganisation;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("keycloak", [])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/users/{userId}".replace("{".concat("userId", "}"), encodeURIComponent(String(requestParameters.userId))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: UserUpdateRequestToJSON(requestParameters.userUpdateRequest)
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return UserResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Update user details  \'Permission#UPDATE_USER\' is required to access to this endpoint
     * Update user details  \'Permission#UPDATE_USER\' is required to access to this endpoint
     */
    UserRestControllerApi.prototype.updateUserAuthorizationUserIdContextOrganisation = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateUserAuthorizationUserIdContextOrganisationRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return UserRestControllerApi;
}(runtime.BaseAPI));
export { UserRestControllerApi };
